
import React, { useEffect } from "react";
import thedeskLogo from "../../assets/Images/press/press-thedesk.png";
import globalnewswire from "../../assets/Images/press/press-globalbewswire-v2.png";
import streamingMedia from '../../assets/Images/press/press-streammedia.png';
import StreamTVInsider from '../../assets/Images/press/press-streamtv-v2.png';
import AdvancedTelevision from '../../assets/Images/press/press-advancedtv.png';
import TheDesk from '../../assets/Images/press/press-thedesk.png';
import TVREV from '../../assets/Images/press/press-tvrev-v2.png';
import TheStreamingWars from '../../assets/Images/press/press-streamingwars-v2.png';
import Yahoo from '../../assets/Images/press/press-yahoo-v2-e1760547871385.png';
import Amagi from '../../assets/Images/press/press-amagi-v2.png';
import TVTech from '../../assets/Images/press/press-tvtec2.png';
import EuropeanLeague from '../../assets/Images/press/press-elf-4.png';
import LinkedIn from '../../assets/Images/press/press-linkedin-v2.png';
import Cablefax from '../../assets/Images/press/press-cablefax-v2.png';
import Variety from '../../assets/Images/press/press-variety-v2.png';

const pressArticles = [
  {
    id: 1,
    logo: thedeskLogo,
    title:
      "Free Live Sports rolls out personalized recommendations through Gizmeon pact",
    description:
      "Free Live Sports has moved its streaming applications to a new technology platform that uses artificial intelligence...",
    date: "October 22, 2026",
    url: "https://thedesk.net/2026/10/free-live-sports-gizmott-personalized-content-recommendations/",
  },
  {
    id: 2,
    logo: globalnewswire,
    title:
      "Media Industry Trailblazers Join Sports Studio Advisory Board, Strengthening the Mission to Make Live Sports Free for Every Fan",
    description:
      "Executives from FuboTV, MTV Networks, Yahoo!, and leading sports and media firms bring decades of successful streaming, ad sales, and sports media expertise to Free Live Sports",
    date: "March 31, 2026",
    url: "https://www.globenewswire.com/news-release/2026/03/31/3265418/0/en/Media-Industry-Trailblazers-Join-Sports-Studio-Advisory-Board-Strengthening-the-Mission-to-Make-Live-Sports-Free-for-Every-Fan.html",
  },
  {
    id: 3,
    logo: streamingMedia,
    title:
      "Free Live Sports Expands Global Footprint, Signing 7 Distribution Deals - 75 Million Homes",
    description:
      "Sports Studio Inc. today announced a major milestone for its flagship streaming platform, Free Live Sports (FLS), securing seven new global distribution deals that will extend the platform’s reach to more than 75 million households worldwide.",
    date: "January 6, 2026",
    url: "https://www.streamingmedia.com/Articles/ReadArticle.aspx?ArticleID=172963",
  },
  {
    id: 4,
    logo: StreamTVInsider,
    title:
      "Free sports streamer FLS secures six global CTV distribution deals",
    description:
      "Sports Studio’s Free Live Sports has secured six new global connected TV distribution deals, as well as another in-car entertainment agreement, that notably expand the sports-focused free streamer’s reach.",
    date: "January 6, 2026",
    url: "https://www.streamtvinsider.com/content/free-sports-streamer-fls-secures-six-global-ctv-distribution-deals",
  },
  {
    id: 5,
    logo: AdvancedTelevision,
    title: "Free Live Sports secures new distribution deals",
    description:
      "Sports Studio has announced that its streaming platform, Free Live Sports (FLS), has secured seven new global...",
    date: "January 6, 2026",
    url: "https://www.advanced-television.com/2026/01/06/free-live-sports-secures-new-distribution-deals/",
  },
  {
    id: 6,
    logo: TheDesk,
    title: "Free Live Sports now reaches 75 million homes",
    description:
      "Streaming television service Free Live Sports (FLS) has inked a multi-platform distribution deal that allows it to reach...",
    date: "January 6, 2026",
    url: "https://thedesk.net/2026/01/free-live-sports-cathy-rasenberger-vidaa-hisense-titan-whale/",
  },
  {
    id: 7,
    logo: TheStreamingWars,
    title: "Everyone Chased Subs. The Smart Money Chased Control",
    description:
      "The streaming industry obsessed over subscriber counts while a few players focused on something more important...",
    date: "October 20, 2025",
    url: "https://www.thestreamingwars.tv/insights/everyone-chased-subs-the-smart-money-chased-control/",
  },
  {
    id: 8,
    logo: TVREV,
    title: "The Future Of FAST May Not Be On TV",
    description:
      "Television has been free and ad-supported since the first TV commercial launched back in the 1940s. In the mid-2010s, companies like...",
    date: "October 19, 2025",
    url: "https://www.tvrev.com/news/the-future-of-fast-may-not-be-on-tv",
  },
  {
    id: 9,
    logo: TheStreamingWars,
    title: "FAST Becomes the Format Behind the Format",
    description:
      "TiVo recently exited hardware. Free Live Sports enters the dashboard. Together, they preview what’s next for streaming infrastructure...",
    date: "October 16, 2025",
    url: "https://www.thestreamingwars.tv/the-take/fast-becomes-the-format-behind-the-format/",
  },
  {
    id: 10,
    logo:  StreamTVInsider,
    title: "TiVo delivers 45 'Free Live Sports' channels to TV/auto",
    description:
      "TiVo added 45 channels from Free Live Sports, to be distributed across its smart TV OEM and IPTV customers...",
    date: "October 15, 2025",
    url: "https://www.streamtvinsider.com/content/tivo-delivers-45-free-live-sports-fast-channels-smart-tvs-auto",
  },
  {
    id: 11,
    logo: Yahoo,
    title: "Free Live Sports to Bring 45 Fast Sports Channels to TiVo",
    description:
      "Agreement Between TiVo and Free Live Sports Enables a Unique Multi-Screen Experience for Sports Fans...",
    date: "October 15, 2025",
    url: "https://finance.yahoo.com/news/free-live-sports-bring-45-120000749.html",
  },
  {
    id: 12,
    logo: TheDesk,
    title:
      "Free Live Sports, TiVo bringing free sports channels to smart TVs & cars",
    description:
      "More than 45 sports content streams are coming to TiVo-powered smart TVs and infotainment systems, the companies said...",
    date: "October 15, 2025",
    url: "https://thedesk.net/2025/10/free-live-sports-tivo-integration/",
  },
  {
    id: 13,
    logo: streamingMedia,
    title: "Monetizing Sports on FAST: A Q&A With Free Live Sports",
    description:
      "Live sports streaming is increasingly where the action is in the streaming and CTV ecosystem, from eye-popping licensing deals to...",
    date: "October 1, 2025",
    url: "https://www.streamingmedia.com/Articles/ReadArticle.aspx?ArticleID=171730",
  },
  {
    id: 14,
    logo: StreamTVInsider,
    title: "FAST content keeps growing, live programming in focus",
    description:
      "The free ad-supported streaming TV (FAST) space has gotten more mature and is not quite the Wild West it was just a few years ago...",
    date: "August 27, 2025",
    url: "https://www.streamtvinsider.com/content/fast-content-keeps-growing-live-programming-focus",
  },
  {
    id: 15,
    logo: Amagi,
    title: "Live Programming: A Catalyst for Streaming Success",
    description:
      "While live programming continues to keep linear TV afloat, it has also emerged as a crucial part of the streaming ecosystem...",
    date: "April 22, 2025",
    url: "https://www.amagi.com/webinars/april-2025",
  },
  {
    id: 16,
    logo: TVTech,
    title: "Will FAST Be a Game-Changer for Sports Television?",
    description:
      "Monday’s 'FAST Play: How Free Ad-Supported Streaming is Changing Sports Broadcasting' session at NAB Show was rife with...",
    date: "April 9, 2025",
    url: "https://www.tvtechnology.com/news/2025-nab-show-will-fast-be-a-game-changer-for-sports-television",
  },
  {
    id: 17,
    logo: Amagi,
    title: "Sports Studio, Inc. Partners with Amagi to Power Premier FAST Sports",
    description:
      "Amagi, a cloud-based SaaS solutions provider for broadcast and streaming TV, announced that it has been chosen by Sports Studio, Inc...",
    date: "March 31, 2025",
    url: "https://www.amagi.com/newsroom/sports-studio-selects-amagi",
  },
  {
    id: 18,
    logo: EuropeanLeague,
    title: "European League of Football launches FAST Channel",
    description:
      "The European League of Football (ELF) is expanding its digital offering and is launching ELF FAST Channel. Fans of American Football...",
    date: "February 2, 2025",
    url: "https://europeanleague.football/news/european-league-of-football-launches-fast-channel-2979",
  },
  {
    id: 19,
    logo: LinkedIn,
    title: "Inside the game: FreeLiveSports.TV's winning formula for sports",
    description:
      "At the helm of this groundbreaking venture are four industry veterans: Cathy Rasenberger, Geoff Clark, Ryan James, and James Patrick...",
    date: "October 11, 2024",
    url: "https://www.linkedin.com/pulse/inside-game-freelivesportstvs-winning-formula-sports-streaming-sp5sf/",
  },
  {
    id: 20,
    logo: TVREV,
    title: "CTV Advertising At A Crossroads, FASTs Reflect A New World Of Sports",
    description:
      "You will not see any stats on what I am about to tell you. Because it is in no one’s best interests to show you these stats...",
    date: "October 4, 2024",
    url: "https://www.tvrev.com/news/wir20241004",
  },
  {
    id: 21,
    logo: Cablefax,
    title: "FAST & Free: Industry Vet Launches Free Live Sports",
    description:
      "Cathy Rasenberger is a well-known name in cable circles, having helped launch more than 40 cable and FAST channels...",
    date: "September 30, 2024",
    url: "https://www.cablefax.com/distribution/fast-free-industry-vet-launches-free-live-sports",
  },
  {
    id: 22,
    logo: TheStreamingWars,
    title: "Free Live Sports Takes FAST by Storm",
    description:
      "Last week, we reported on Victory+ launching its own sports FAST service, and now the field is expanding further...",
    date: "September 30, 2024",
    url: "https://thestreamingwars.tv/news/free-live-sports-takes-fast-by-storm/",
  },
  {
    id: 23,
    logo: StreamTVInsider,
    title: "FAST 'Free Live Sports' launches with more than 100 channels",
    description:
      "It’s been said before: free, live football is all that’s holding the traditional TV ecosystem together...",
    date: "September 30, 2024",
    url: "https://www.streamtvinsider.com/video/fast-live-sports-tv-launches-more-100-channels",
  },
  {
    id: 24,
    logo: Variety,
    title:
      "Streaming Platform Free Live Sports Launches With More Than 100 Sports-Centric FAST Channels",
    description:
      "Streaming platform Free Live Sports has launched with a selection of 100+ live FAST (free, ad-supported TV) sports channels as well as rights to thousands of sports movies, docs, series and highlights.",
    date: "September 30, 2024",
    url: "https://variety.com/2024/tv/news/free-live-sports-100-fast-channels-streaming-platform-1236158372/",
  },
];


const Press = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="press_page">
      <div className="wrapper">
        <div className="press_container">
            <div className="press_header">
                <div className="press_title">
                <h1>Press &amp; Media</h1>
                <span className="press_title_line" />
                <h6>Sports Studio: FreeLiveSports.tv in the news.</h6>
                </div>
            </div>
         <div className="press_articles">
          {pressArticles.map((article) => (
            <a
              className="press_card_link"
              key={article.id}
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Read article: ${article.title}`}
            >
              <article className="press_card">
                <div className="press_publication">
                  <img
                    className="press_logo"
                    src={article.logo}
                    alt=""
                    onError={(event) => {
                      event.currentTarget.style.display = "none";
                    }}
                  />
                </div>

                <div className="press_article_link">
                  <h2>{article.title}</h2>
                </div>

                <p className="press_description">
                  {article.description}
                </p>

                <div className="press_card_divider" />

                <time className="press_date">{article.date}</time>
              </article>
            </a>
          ))}
        </div>      
        </div>
     
      </div>
    </div>
  );
};

export default Press;
